module.exports = __webpack_public_path__ + "img/valuation_final-img.9418d5d8.svg";